export const getDeductionDate = (scheduledDate?: Date | null, effectiveScheduledDate?: Date | null) =>
  effectiveScheduledDate || scheduledDate;
